export enum FilterEngineMode {
  FAVORITE = 'FAVORITE',
  CLASSIC = 'CLASSIC'
}
